<template>
  <b-sidebar
    id="sidebar-add-student"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Add student') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="studentCreate">

          <!-- Period -->
          <b-form-group
            :label="$t('Student')"
            label-for="student"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Student')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="user"
                :reduce="(option) => option.id"
                :options="students"
                :get-option-label="(option) => option.user.full_name"
                @search="search"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Add') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { debounce } from 'lodash'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fetchDebounced: debounce(this.fetch, 500),
      required,
      user: null,
    }
  },
  computed: {
    researchAdvisor() {
      return this.$store.state[this.MODULE_NAME].researchAdvisor
    },
    students() {
      return this.$store.state[this.MODULE_NAME].students
    },
  },
  mounted() {
    localize(this.$i18n.locale)
    this.fetch('', () => {})
  },
  methods: {
    clear(hide) {
      this.$refs.studentCreate.reset()
      this.user = null
      hide()
    },
    submit(hide) {
      this.$refs.studentCreate.validate().then(success => {
        if (success) {
          const data = {
            advisor_id: this.researchAdvisor.user.id,
            apply_id: this.user,
          }
          this.$createSwal(this, data, `${this.MODULE_NAME}/addStudent`, () => {
            this.$emit('refetchData')
            this.clear(hide)
          })
          hide()
        }
      })
    },
    fetch(search, loading) {
      this.$store.dispatch(`${this.MODULE_NAME}/students`, { search }).then(() => {
        loading(false)
      })
    },
    search(search, loading) {
      loading(true)
      this.fetchDebounced(search, loading)
    },
  },
  setup() {
    const MODULE_NAME = 'researchAdvisor'
    return {
      MODULE_NAME,
    }
  },
}
</script>
